import {useDispatch, useSelector} from 'react-redux'
import {AppStore} from '../redux/store'
import {
  addTabAction,
  changeTabAction,
  deleteTabAction,
  setCurrentTabItemAction,
  setMenuFromApi,
} from '../redux/states/hoteleria'
import {TabModel} from '../models'
import {useState} from 'react'

export const useHoteleria = () => {
  const hoteleriaState = useSelector((store: AppStore) => store.hoteleria)
  const {tabs, currentTab} = hoteleriaState
  const currentTabItem = tabs[currentTab] || null
  const dispatch = useDispatch()
  const [showModalSearch, setShowModalSearch] = useState(false)
  const changeTab = (index: number) => {
    dispatch(changeTabAction(index))
  }

  const changeCurrentTabItem = (tab: TabModel) => {
    dispatch(setCurrentTabItemAction(tab))
  }

  const addTab = (newTab: TabModel) => {
    dispatch(addTabAction(newTab))
    return hoteleriaState.tabs.length
  }

  const setMenu = (menu: any[]) => {
    dispatch(setMenuFromApi(menu))
  }

  const deleteTab = (index: number) => {
    const updatedTabs = [...tabs]
    updatedTabs.splice(index, 1)
    dispatch(deleteTabAction(updatedTabs))
  }

  const isAllowed = (action: string) => {
    return currentTabItem.opciones?.some((item) => item.opcion === action)
  }

  return {
    panel: hoteleriaState.showPanel,
    currentTabItem,
    tabs: hoteleriaState.tabs,
    currentTab: hoteleriaState.currentTab,
    menu: hoteleriaState.menu,
    addTab,
    deleteTab,
    changeTab,
    showModalSearch,
    setShowModalSearch,
    changeCurrentTabItem,
    setMenu,
    isAllowed,
  }
}
